import styled from 'styled-components';
import { media } from 'public/styles';
import { FlexBox, Box, Headline, Message } from '@Backlot-Cars/archie';

export const Grouper = styled(Box)`
	display: grid;
	gap: ${({ gap }) => gap || 0}px;
`;

export const LoginContainer = styled(FlexBox).attrs({
	position: 'relative',
	width: '100%',
	height: '-webkit-fill-available',
	maxWidth: '460px',
	flexDirection: 'column',
	alignItems: 'baseline',
	justifyContent: 'baseline',
	gap: 'md',
})`
	@media ${media.greaterThanUltraWide} {
		max-width: 100%;
	}

	@media ${media.smallest} {
		max-width: 100%;
		padding: 0 16px;
	}

	@media ${media.smaller} {
		align-items: center;
		justify-content: center;
	}

	@media ${media.larger} {
		justify-content: center;
	}
`;

export const LogoContainer = styled(FlexBox).attrs({
	position: 'static',
	zIndex: 2,
})`
	@media ${media.smaller} {
		justify-content: center;
	}
`;

export const FormWrapper = styled(FlexBox).attrs({
	height: '100%',
	flexDirection: 'column',
	width: '100%',
	maxWidth: '460px',
	alignSelf: 'center',
	margin: 'auto',
})`
	@media ${media.largest} {
		max-width: 460px;
	}

	@media ${media.smaller} {
		max-width: 100%;
	}
`;

export const AppStoreIcons = styled(FlexBox).attrs({
	gap: 'md',
	justifyContent: 'center',
	alignItems: 'center',
	margin: '48px 0 0 0',
})`
	@media ${media.smaller} {
		margin-top: 24px;
	}

	svg {
		height: auto !important;
		display: block;
	}
`;

export const ForgotPasswordLink = styled(FlexBox)`
	justify-content: center;
	margin: 32px 0 0 0;
`;

export const StyledHeadline = styled(Headline)`
	color: {dsColors.colorBrand.secondary};
`;

export const StyledMessage = styled(Message)`
	margin: 16px 0 0 0;
`;
